import { AccountContainer } from "./account_container";
import { PageContainer } from "./page_container";
export const ApiProxy = { AccountContainer, PageContainer };
//# sourceMappingURL=proxy.js.map